import styled, {
  injectGlobal,
} from 'styled-components';
import Flex from './Flex/Flex'; import VirtualList from './Virtualized/VirtualList/VirtualList';
import GridList from './Virtualized/GridList/GridList';

// eslint-disable-next-line no-unused-expressions
injectGlobal`
  @font-face {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
    font-style: normal;
    font-weight: normal;
    src: url('./assets/fonts/OpenSans-Light.ttf') format('truetype');
  }
  @font-face {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
    font-style: normal;
    font-weight: 500;
    src: url('./assets/fonts/OpenSans-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
    font-style: normal;
    font-weight: 600;
    src: url('./assets/fonts/OpenSans-Semibold.ttf') format('truetype');
  }
  @font-face {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
    font-style: normal;
    font-weight: 700;
    src: url('./assets/fonts/OpenSans-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
    font-style: normal;
    font-weight: 800;
    src: url('./assets/fonts/OpenSans-ExtraBold.ttf') format('truetype');
  }
  html, body {
    height: 100%;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
  }
  body {
    color: #333;
    font-size: 14px;
    line-height: 1.42857142857143;
    margin: 0 !important;
  }
  #app {
    height: 100%;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 2px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border: 5px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #88a7db;
    border: 0px solid transparent;
    border-radius: 8px;
    background-clip: content-box;
  }

  .ReactVirtualized__Grid {
    outline: none;
  }
`;

export const JiraLink = styled.a`
  color: #7a869a;
  font-size: 12px;
  text-decoration: none;

  &:hover {
    color: #3572b0;
    text-decoration: underline;
  }
`;

export const PopupContent = styled.div`
  font-size: 13px;
  cursor: default;
  padding: 2px 0px;
  background: white;
  min-width: 132px;
  max-height: 1000px;
  border-radius: 5px;
`;

export const PopupInner = styled.div`
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;

export const PopupHeader = styled.div`
  display: flex;
  flex-flow: column nowrap;
  padding: 16px;
  justify-content: center;
`;

export {
  Flex,
  GridList,
  VirtualList,
};
